export function done(callback) {
  return (data) =>
    callback ?
    callback(null, data) :
    data
  ;
}

export function error(callback) {
  return (err) =>
    callback ?
    callback(err && err.body || err) :
    Promise.reject(new Error(err && err.body) || err)
  ;
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/v2/applicants/common.js